import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import NumberInput from "../../../../components/inputs/number";
import TextInput from "../../../../components/inputs/text";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import InstanceCard from "./card";
import { IndexHook } from "./hooks";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	// setLoading,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		handleSubmit,

		loading,
		// setValue,
		// control,
		// setFocus,
		//formState
		errors,
		isSubmitting,

		id_instagram,
		descricao,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		// setLoading,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Carregando..." />
				</div>
			) : (
				<form
					className="form"
					onSubmit={handleSubmit(
						handleOnSubmit
						// handleOnError
					)}
				>
					<main>
						{id_instagram === 0 ? (
							<>
								<div className="row">
									<TextInput
										label="Nome do Usuário"
										id="descricao"
										placeholder=""
										register={register}
										errors={errors}
										onKeyDown={libForm.EnterTab}
										autoFocus={true}
										className="col-12"
										toUpperCase={false}
									/>
								</div>
							</>
						) : (
							<div className="px-4 w-60">
								<InstanceCard
									descricao={descricao}
									id_instagram={id_instagram}
									// onDelete={() => deleted(id_whatsapp)}
								/>
							</div>
						)}
					</main>
					<footer>
						<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						{id_instagram === 0 && <BtnSubmit isSubmitting={isSubmitting} />}
					</footer>
				</form>
			)}
		</>
	);
};

export default Form;

{
	/* <TextInput
								label="Código do Instagram"
								id="cod_conta"
								placeholder=""
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12"
								toUpperCase={false}
							/>
							<TextInput
								label="Token do Instagram"
								id="token_instagram"
								placeholder=""
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-12"
								toUpperCase={false}
							/> */
}
